import Vue from 'vue'
import Router from 'vue-router'
import TitanHome from '@/components/TitanHome'
import TitanTicket from '@/components/TitanTicket'
import TitanLogin from '@/components/TitanLogin'
import TitanMyTickets from '@/components/TitanMyTickets'
import TitanReprint from '@/components/TitanReprint'
import TitanCashflow from '@/components/TitanCashflow'
import TitanPIXQRCode from '@/components/TitanPIXQRCode'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'TitanHome',
      component: TitanHome
    },
    {
      path: '/ticket/:id',
      name: 'TitanTicket',
      component: TitanTicket
    },
    {
      path: '/login',
      name: 'TitanLogin',
      component: TitanLogin
    },
    {
      path: '/mytickets',
      name: 'TitanMyTickets',
      component: TitanMyTickets
    },
    {
      path: '/reprint/:id',
      name: 'TitanReprint',
      component: TitanReprint
    },
    {
      path: '/cashflow',
      name: 'TitanCashflow',
      component: TitanCashflow
    },
    {
      path: '/pixqrcode/:id',
      name: 'TitanPIXQRCode',
      component: TitanPIXQRCode
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js